<template>
    <tbody>
        <tr class="budget-row" :class="{'active': showChildren}">
            <td>
                <button v-on:click="toggleChildren"> {{ toggleText }} </button>
                <strong>{{ name }}</strong>
            </td>
            <Cell 
                v-for="(budget, index) in totals" 
                :budget="budget" 
                :key="index" 
            />
        </tr>
        <RowChild 
            v-for="(child, index) in children" 
            :child="child" 
            :key="index" 
            :years="years"
            v-on:totalUpdate="sumBudgets"
        />
        <tr class="budget-row-total">
            <td>Subtotal</td>
            <Cell 
                v-for="(budget, index) in totals" 
                :budget="budget" 
                :key="index" 
            />
        </tr>
    </tbody>
</template>

<script>
import RowChild from '@/components/RowChild';
import Cell from '@/components/Cell';

export default {
    name: 'Row',
    props: {
        'name' : String,
        'children' : Array,
        'years' : Array
    },
    data() {
        return {
            showChildren: false,
            totals: {}
        }
    },
    components: {
        RowChild,
        Cell
    },
    computed: {
        toggleText() {
            return (this.showChildren) ? '-' : '+';
        }
    },
    methods: {
        toggleChildren() {
            this.showChildren = (this.showChildren) ? false : true;
        },
        sumBudgets(childBudget) { /* Add child budget to parent budget */
            this.totals = this.sumObjectsByKey(this.totals, childBudget);
        },
        sumObjectsByKey(...objs) { /* Add two objects based off key name */
            return objs.reduce((a, b) => {
                for (let k in b) {
                if (b.hasOwnProperty(k))
                    a[k] = (a[k] || 0) + +b[k];
                }
                return a;
            }, {});
        }
    }
}
</script>

<style lang="scss">
    .budget-row {
        td:first-child {
            padding-left: 12px;
        }
        button {
            display: inline-block;
            margin-right:10px;
            font-weight: bold;
            font-size: 16px;
            float:left;
            color:#333;
            background: #ccc;
            border: 0px;
            height: 30px;
            width: 30px;
            cursor: pointer;
        
            &:hover {
                color:#fff;
                background: #000;
            }   
        }
        &.active {
            td:not(:first-child) span {
                display:none;
            }
            ~ .budget-row-child,
            ~ .budget-row-total {
                display: table-row;
            }
            ~ .budget-row-total {
                border-top:4px solid #000;
                font-weight:bold;
                background: #fff;

                td {
                    padding-bottom:30px;
                }
            }
        }
    } 

    .budget-row-child,
    .budget-row-total{
        display: none;
        
        td:first-child {
            padding-left: 35px;
        }
    }

</style>
